import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { CONFIG } from '../../config';
import { Tag } from '../../shared/models/tag.model';
import { AbstractCRUD, CRUDService, ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';

@Injectable({
  providedIn: 'root'
})
export class TagService extends AbstractCRUD<Tag> implements CRUDService<Tag> {
  private config = CONFIG;

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService
  ) {
    super(exceptionService, http, utilsService);
  }

  getResourcePath(): string {
    return '/rms/tag';
  }

  getTagsForTextContent(id: number, params?: object) {
    return this.getHTTP().get<PaginatedList<Tag>>(`${this.config.apiUrl}/rms/note/${id}/tag?pagesize=${CONFIG.pagination.singleLargePage}`)
      .pipe(catchError(ex => this.getException().catchBadResponse(ex)));
  }

  attachTagToNote(noteId: number, tagId: number) {
    return this.getHTTP().post(`${this.config.apiUrl}/rms/note/${noteId}/tag/${tagId}/attach`, null)
      .pipe(catchError(ex => this.getException().catchBadResponse(ex)));
  }

  detachTagFromNote(noteId: number, tagId: number) {
    return this.getHTTP().post(`${this.config.apiUrl}/rms/note/${noteId}/tag/${tagId}/detach`, null)
    .pipe(catchError(ex => this.getException().catchBadResponse(ex)));
  }
}
